import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { of } from 'rxjs/internal/observable/of';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceExportExcel } from 'src/app/core/services/export.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { AuditLogComponent } from 'src/app/shared/audit-log/audit-log/audit-log.component';
import { ExceptionUsersComponent } from 'src/app/pages/routing/trips/trip-view/exception-users/exception-users.component';
import { TripMapComponent } from 'src/app/pages/routing/trips/trip-view/trip-map/trip-map.component';


@Component({
  selector: 'app-vendor-trips',
  templateUrl: './vendor-trips.component.html',
  styleUrls: ['./vendor-trips.component.scss']
})
export class VendorTripsComponent implements OnInit {

  _mTitle: string = "Trip View";
  address: any = true;
  areaLandmark: any = false;
  _mReturnUrl: any;
  siteid: number;
  shiftid: number;
  date: any;
  tripsheet: any;
  tripViewList: any[] = [];
  checkedTrips: any = [];
  exceldata: any = [];
  siteData: any[] = [];
  tripModifyFile: string;
  tripSummary: any;
  missingUsers: any[] = [];
  tripUsersId: any[] = [];
  tempTripUsersId: any[] = [];
  exceptionEmployee: any[] = [];
  checkedFlag: boolean = false;
  routingType: any;
  searchTrip: any;
  displayedRows$: any[] = [];
  mapType: any;
  tripdetails: any = [];
  escortId: any;
  escort: any = [];
  escortFlag: boolean = false;
  seatsOccupiedPercentFlag: boolean = false;
  showHideAddress: boolean = false;
  showContact: boolean = false;
  maskingEnabled = false;
  roleName: any;
  allExpandState: any;
  tempTripId: any;
  mTravelTime: any;
  routingConfigTime: any;
  travelTimeFlag: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private readonly apiService: ApiService,
    private serviceExportExcel: ServiceExportExcel,
    private serviceLocalStorage: ServiceLocalStorage,
    private serviceSharedData: ServiceSharedData,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.roleName = this.serviceLocalStorage.getJsonValue("role-name");
    if (this.serviceLocalStorage.getRoleName() == 'Admin' || this.serviceLocalStorage.getRoleName() == 'Super Admin' || this.serviceLocalStorage.getRoleName() == 'Site Admin') {
      this.travelTimeFlag = true;
    } else {
      this.travelTimeFlag = false;
    }
    this.checkMaskingEnabled();
    this.route.params.subscribe(params => {
      this.siteid = params["siteId"];
      this.shiftid = params["shiftId"];
      this.date = params["date"];
    });
    this.mapType = this.serviceLocalStorage.getMapType();
    this.getAllEscortBasedOnSiteId(this.siteid);
  }

  getAllEscortBasedOnSiteId(siteid: number) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getEscortListBySiteId + siteid, success => {
      if (success) {
        this.escort = success.body;
      }
    }, error => {
      console.log(error)
    });
  }

  checkMaskingEnabled() {
    const clientCode = localStorage.getItem("clientCode")
    this.apiService.doGetRequestWithResponse(ApiConstants.checkMaskingEnabled + clientCode, success => {
      if (success.status === 200) {
        this.maskingEnabled = success.body.maskingEnabled;
      }
      if (!this.maskingEnabled) {
        this.showHideAddress = true;
        this.showContact = true;
      }
    }, error => {
      if (!this.maskingEnabled) {
        this.showHideAddress = true;
        this.showContact = true;
      }
    })
  }

  sortData(sort: Sort) {
    const data = this.tripViewList.slice();
    if (!sort.active || sort.direction === '') {
      this.displayedRows$ = data;
      return;
    }
    this.displayedRows$ = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'tripCode': return this.compare(a.tripCode, b.tripCode, isAsc);
        case 'vehicleNo': return this.compare(a.vehicleNo, b.vehicleNo, isAsc);
        case 'vendor': return this.compare(a.Vendor, b.Vendor, isAsc);
        case 'driver': return this.compare(a.Driver, b.Driver, isAsc);
        case 'vehicleType': return this.compare(a.vehicleType, b.vehicleType, isAsc);
        case 'zoneName': return this.compare(a.zone, b.zone, isAsc);
        case 'routeName': return this.compare(a.routeName, b.routeName, isAsc);
        case 'area': return this.compare(a.pickupDropPoint, b.pickupDropPoint, isAsc);
        case 'escort': return this.compare(a.escort, b.escort, isAsc);
        case 'distance': return this.compare(a.distance, b.distance, isAsc);
        case 'distanceCovered': return this.compare(a.distanceCovered, b.distanceCovered, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loadData();
    });
  }

  loadData() {
    this.tripViewList = [];
    this.displayedRows$ = [];
    this.getSites();
    this.getSummary();
    this.getRoutingConfigBySiteId();
    const rows$ = of(this.tripViewList);
    this.displayedRows$ = this.tripViewList;
  }

  getSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getActiveSitesbyUser, success => {
      this.siteData = success.body.filter(
        site => site.siteId == this.siteid
      );
    }, error => {
      console.log(error)
    });
  }

  getSummary() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getTripSummary + this.siteid + '&shiftid=' + this.shiftid + '&date=' + this.date, success => {
      this.tripSummary = success.body;
      this.getTripSheet();
    }, error => {
      console.log(error)
    });
  }

  updateEmployeeTravelTime(emp) {
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(ApiConstants.updateEmployeePickUpTime + this.siteid + '&tripUserId=' + emp.tripUserId + '&tripTravelTime=' + emp.time, '', success => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        this.notifyService.showSuccess("Updated successfully", null);
      } else {
        this.notifyService.showWarning("Update Failed. Please check Routing Config ", null);
      }
    }, error => {
      this.ngxLoader.stop();
      console.log(error)
    })
  }

  onTimeValidate(value, emp) {
    emp.time = value;
  }

  omit_special_char_And_String1(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return (k == 58 || (k >= 48 && k <= 57));
  }

  checkAll(event) {
    this.checkedTrips = [];
    if (event.checked) {
      this.tripViewList.forEach(trip => {
        this.checkedTrips.push(trip.tripid);
      });
      this.checkedFlag = true;
    } else {
      this.tripViewList.forEach(trip => {
        let index: number = this.checkedTrips.indexOf(trip.tripid);
        if (index !== -1) {
          this.checkedTrips.splice(index, 1);
        }
      });
      this.checkedFlag = false;
    }
  }

  onClickBack() {
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.tripViewFlag, true);
    this.router.navigate(["/myatom/routing/vendortripview"]);
  }

  getTripSheet() {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.getTripSheet + this.siteid + '&shiftid=' + this.shiftid + '&date=' + this.date, success => {
      if (success.status == 200) {
        this.tripsheet = success.body;
        this.routingType = success.body[0].tripDetails.routingType
        this.ngxLoader.stop();
        this.tripSummary.SECURITY = 0;
        this.tripsheet.forEach(element => {
          let tripemp: any = [];
          if (element.tripDetails.escortStatus) {
            this.tripSummary.SECURITY = this.tripSummary.SECURITY + 1;
          }
          element.tripDetails.tripUsers.forEach(tripuser => {
            let vflag = false;
            tripemp.push({
              tripUserId: tripuser.id,
              employeeId: tripuser.tripUser.userInfoDetails.employeeId == null ? "" : tripuser.tripUser.userInfoDetails.employeeId,
              employeeName: tripuser.tripUser.userInfoDetails.displayName == null ? "" : tripuser.tripUser.userInfoDetails.displayName,
              gender: tripuser.tripUser.userInfoDetails.gender == null ? "NA" : tripuser.tripUser.userInfoDetails.gender,
              userid: tripuser.tripUser.id,
              bookingid: tripuser.booking ? tripuser.booking.bookingId : null,
              address: tripuser.tripUser.userInfoDetails.address == null ? "NA" : tripuser.tripUser.userInfoDetails.address,
              distance: tripuser.empTripDistance == null ? "0" : tripuser.empTripDistance,
              time: tripuser.pickupDropTime ? tripuser.pickupDropTime.slice(0, -3) : "00:00",
              userColor: tripuser.tripUser.userInfoDetails.userCategory[0] == null ? "#006aa8" : tripuser.tripUser.userInfoDetails.userCategory[0].categories.colorCode,
              medical: vflag,
              showstatus: tripuser.showStatus == null ? "NO SHOW" : tripuser.showStatus,
              contact: tripuser.tripUser.userInfoDetails.contactNumber == null ? "NA" : tripuser.tripUser.userInfoDetails.contactNumber,
              adtime: element.tripDetails.shift.logType == "IN" ? tripuser.boardedDateTime : tripuser.arrivalDateTime,
              outOfSiteBoundry: tripuser.landmark.isOutOfSiteBoundary == null ? null : tripuser.landmark.isOutOfSiteBoundary,
              area: tripuser.tripUser.userInfoDetails.pickUpDrop == null ? "NA" : tripuser.tripUser.userInfoDetails.pickUpDrop.area.area,
              landMark: tripuser.tripUser.userInfoDetails.pickUpDrop == null ? "NA" : tripuser.tripUser.userInfoDetails.pickUpDrop.landmark,
              smsStatus: tripuser.smsStatus,
              buildingName:tripuser.buildingName
            });
          });
          this.tripViewList.push({
            tripid: element.tripDetails.tripId == null ? "" : element.tripDetails.tripId,
            tripCode: element.tripDetails.tripCode == null ? "NA" : element.tripDetails.tripCode,
            tripstatus: element.tripDetails.tripstatus == null ? "" : element.tripDetails.tripstatus,
            vehicleNo: element.vehicle == null ? "NA" : element.vehicle.registrationNo,
            Vendor: element.vendorMaster == null ? "NA" : element.vendorMaster.name,
            Driver: element.driver == null ? "NA" : element.driver.name,
            Number: element.driver == null ? "NA" : element.driver.contactNumber,
            pickupDropPoint: element.tripDetails.shift.logType == "IN" ? this.routingType == "ALGORITHM"
              ? element.tripDetails.tripUsers[0].tripUser.userInfoDetails.address : element.tripDetails.tripUsers[0].tripUser.userInfoDetails.pickUpDrop.area == null
                ? "NA" : element.tripDetails.tripUsers[0].tripUser.userInfoDetails.pickUpDrop.area.area : this.routingType == "ALGORITHM"
              ? element.tripDetails.tripUsers[tripemp.length - 1].tripUser.userInfoDetails.address
              : element.tripDetails.tripUsers[tripemp.length - 1].tripUser.userInfoDetails.pickUpDrop.area == null
                ? "NA" : element.tripDetails.tripUsers[tripemp.length - 1].tripUser.userInfoDetails.pickUpDrop.area.area,
            deviceTripStatus: element.DeviceTripStatus == null ? "" : element.DeviceTripStatus,
            zone: element.tripDetails.zone == null ? 'NA' : element.tripDetails.zone.name,
            routeName: element.tripDetails.routeName == null ? 'NA' : element.tripDetails.routeName,
            masterRouteName: element.tripDetails.masterRouteName,
            vehicleType: element.vehicleType.vehicleType,
            escort: element.tripDetails.escortStatus == false ? "NO" : "YES",
            distance: element.tripDetails.tripDistance == null ? "0" : element.tripDetails.tripDistance,
            distanceCovered: element.distanceCovered == null ? "0" : element.distanceCovered,
            seatCapacity: element.vehicleType.seatCapacity,
            seatsOccupied: tripemp.length == null ? "0" : tripemp.length + (element.tripDetails.escortStatus ? 1 : 0),
            tripemp: tripemp,
            escortname: element.escort == null ? "" : element.escort.name,
            alloacateVehicle: element.vehicle == null ? "NA" : element.vehicle.vehicleType.vehicleType,
            triptraveltime: element.tripDetails.tripTravelTime,
            shift: element.tripDetails.shift.shiftTime + " " + element.tripDetails.shift.logType,
            logType: element.tripDetails.shift.logType,
            date: element.tripDetails.tripDate.split(" ")[0],
            seatsOccupiedPercent: (element.tripDetails.escortStatus ? (((tripemp.length + 1) / element.vehicleType.seatCapacity) * 100)
              : ((tripemp.length / element.vehicleType.seatCapacity) * 100)).toFixed(0),
            tatd: element.startDateTime == null ? "" : element.startDateTime,
            stopTime: element.stopDateTime == null ? "" : element.stopDateTime
          });
        });
      } else {
        this.ngxLoader.stop();
        this.notifyService.showInfo("No Trips Found", null);
        this.router.navigate(["/myatom/routing/trips"]);
      }
    }, error => {
      this.ngxLoader.stop();
      this.notifyService.showInfo("No Trips Found", null);
    });
  }

  mapview(tripid) {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.gettripbytripid + '?tripid=' + tripid, success => {
      let reqData = {
        params: {
          siteId: this.siteid,
          shiftId: this.shiftid,
          date: this.date
        },
        data: success.body,
        mapType: this.mapType
      };
      this.dialog.open(TripMapComponent, {
        width: '1250px',
        disableClose: true,
        data: reqData
      });
      this.ngxLoader.stop();
    }, error => {
      this.notifyService.showInfo("No Trips Found", null);
      this.ngxLoader.stop();
    });
  }

  getTripDetails(tripids) {
    let driverstatusflag = true;
    let locTripId = 0;
    let locDriverStatus = "";
    this.apiService.doPostRequestWithResponse(ApiConstants.gettripsbytripids + tripids, '', success => {
      if (success.status == 200) {
        this.tripdetails = success.body[0];
        this.tripdetails.forEach(trip => {
          if (trip.DeviceTripStatus != "not started") {
            driverstatusflag = false;
            locTripId = trip.tripDetails.tripCode;
            locDriverStatus = trip.DeviceTripStatus;
          }
        });
        if (driverstatusflag) {
          this.serviceSharedData.setData("trips", this.checkedTrips);
          this.router.navigate(["/myatom/routing/tripmodify", this.siteid, this.shiftid, this.date, false]);
        } else {
          this.notifyService.showWarning(locTripId + " can't modify.trip is already " + locDriverStatus, null);
        }
      }
    }, error => {
      this.ngxLoader.stop();
    });
  }

  modifyTrip() {
    if (this.checkedTrips.length < 1) {
      this.notifyService.showWarning("Select atleast one trip to modify", null);
    } else {
      this.getTripDetails(this.checkedTrips);
    }
  }

  checkTrip(event, tripid) {
    event.checked ? this.checkedTrips.push(tripid) : this.checkedTrips.splice(this.checkedTrips.indexOf(tripid), 1);
  }

  downloadAL(): void {
    this.exceldata = [];
    let data: any = {};
    let number = 1;
    this.tripViewList.forEach(element => {
      this.exceldata.push({
        tripCode: element.tripCode,
        vehicleNo: element.vehicleNo,
        vendor: element.Vendor,
        driver: element.Driver,
        contactNo: element.Number,
        location: element.pickupDropPoint,
        vehicleType: element.vehicleType,
        escortRequired: element.escort,
        escortName: element.escortname,
        planneDistance: element.distance,
        distanceCovered: element.distanceCovered,
        seatCapacity: element.seatCapacity,
        seatOccupied: element.seatsOccupied,
        allocateVehicle: element.alloacateVehicle,
        tripTravelTime: element.triptraveltime,
        site: this.siteData[0].siteName,
        shift: element.shift,
        date: element.date,
        seatOccupiedPercent: element.seatsOccupiedPercent
      });
      this.exceldata.push({
        tripCode: "EmployeeId",
        vehicleNo: "EmployeeName",
        vendor: "Gender",
        driver: "Distance",
        contactNo: "Time",
        location: "Medical",
        vehicleType: "TravelStatus",
        escortRequired: "Contact",
        escortName: (this.routingType === 'FIXED') ? 'RouteName' : 'ZoneName',
        distance: 'Address',
        seatCapacity: 'Area'
      });
      element.tripemp.forEach(element1 => {
        this.exceldata.push({
          tripCode: element1.employeeId,
          vehicleNo: element1.employeeName,
          vendor: element1.gender,
          driver: element1.distance,
          contactNo: element1.time,
          location: element1.medical,
          vehicleType: element1.showstatus,
          escortRequired: element1.contact,
          escortName: (element.masterRouteName != null) ? '(M)' + element.masterRouteName : (this.routingType === 'FIXED') ? element.routeName : element.zone,
          distance: element1.address,
          seatCapacity: element1.area
        });
      });
      if (number < this.tripViewList.length) {
        this.exceldata.push({}, {
          tripCode: "tripCode",
          vehicleNo: "vehicleNo",
          vendor: "vendor",
          driver: "driver",
          contactNo: "contactNo",
          location: "location",
          vehicleType: "vehicleType",
          escortRequired: "escortRequired",
          escortName: "escortName",
          distance: "distance",
          seatCapacity: "seatCapacity",
          seatOccupied: "seatOccupied",
          allocateVehicle: "allocateVehicle",
          tripTravelTime: "tripTravelTime",
          site: "site",
          shift: "shift",
          date: "date",
          seatOccupiedPercent: "seatOccupiedPercent"
        });
      }
      number++;
    });
    this.serviceExportExcel.exportAsExcelFileForTrips(this.exceldata, "Trips");
  }

  showExceptionEmployees() {
    let data = { date: this.date, siteid: this.siteid, shiftid: this.shiftid };
    let dialogRef = this.dialog.open(ExceptionUsersComponent, {
      data: data,
      width: "1250px",
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  percentage4BgColor(p) {
    return p <= 30 ? "#f32727" : p <= 50 ? "#ff6262" : p <= 90 ? "#cc9595" : undefined;
  }

  modified4BgColor(p) {
    if (p.tripstatus === "MODIFIED") return "#33ff99";
    if (p.tripemp?.some(emp => emp.outOfSiteBoundry)) return '#FFFF00';
    if (p.tripstatus === "VENDOR_PUSHBACKED") return "#D4FF33";
  }

  getAudit(e) {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.getTripViewAuditById + '?id=' + e.tripid + '&vendorMasterId=' + "", success => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        let data = success.body;
        let object = Object.entries(e);
        data.data.push(object[1]);
        this.dialog.open(AuditLogComponent, {
          data: data,
          disableClose: true
        });
      } else {
        this.notifyService.showInfo("No audit logs found", null);
      }
    }, error => {
      this.ngxLoader.stop();
    });
  }

  onChangeForEscort(event, tripid, p, v, d) {
    if (v === "NA" && d === "NA") return this.notifyService.showWarning("Please allocate vehicle and driver to trip", null);
    if (p >= 100) return this.notifyService.showWarning("All Seats Occupied So Please Change VehicleType", null);
    this.escortAddingTotrip(tripid, event.value);
  }

  escortAddingTotrip(tripId: number, escortId: number) {
    this.apiService.doPostRequestWithResponse(ApiConstants.addingEscortToTrip + '?tripId=' + tripId + '&escortId=' + escortId, '', success => {
      if (success.status == 200) {
        this.notifyService.showSuccess(success.body.message, null);
      }
      this.loadData();
    }, error => {
      this.notifyService.showError(error.message, null);
    });
  }

  getRoutingConfigBySiteId() {
    let data = { siteid: this.siteid, shiftid: this.shiftid };
    this.apiService.doGetRequestWithResponse(ApiConstants.getRoutingConfigBySiteId + '?siteId=' + data.siteid + '&shiftTimeId=' + data.shiftid, (success) => {
      if (success.status == 200) {
        this.routingConfigTime = success.body.time;
      }
    }, (error) => {
      console.log(error)
    })
  }

}
